export const scrollToPurchase = (e?: React.MouseEvent) => {
  if (e) e.preventDefault()
  const element = document.getElementById('purchase-section')
  if (element) {
    element.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }
}
